/**
 * Paypal order example
 * {
 *     amount: {
 *         currency_code: 'EUR',
 *         value: "30",
 *         breakdown: {
 *             item_total: {
 *                 currency_code: 'EUR',
 *                 value: "10",
 *             },
 *             shipping: {
 *                 currency_code: 'EUR',
 *                 value: "10",
 *             },
 *             tax_total: {
 *                 currency_code: 'EUR',
 *                 value: "10",
 *             }
 *         }
 *         // shipping_discount
 *         // discount
 *     },
 *     items: [
 *         {
 *             name: 'nome prodotto',
 *             unit_amount: {
 *                 currency_code: 'EUR',
 *                 value: "10",
 *             },
 *             tax: {
 *                 currency_code: 'EUR',
 *                 value: "0",
 *             },
 *             quantity: 1,
 *             sku: 'XXXXXX1'
 *             // description: 'descrzione'
 *             // category
 *         }
 *     ],
 *     shipping: {
 *         name: {
 *             full_name: 'Paolo Rossi'
 *         },
 *         type: 'SHIPPING',
 *         address: {
 *             address_line_1: 'street',
 *             country_code: 'IT',
 *             postal_code: '41120',
 *             admin_area_2: 'Modena',
 *             admin_area_1: 'Italy'
 *         }
 *     },
 *     payer: {
 *         email_address: 'paypalec-buyer@pollini.com',
 *         name: {
 *             given_name: 'name',
 *             surname: 'surname',
 *         },
 *         phone: {
 *             phone_number: 'phone'
 *         },
 *         address: {
 *             address_line_1: 'street',
 *             country_code: 'IT',
 *             postal_code: '41120',
 *             admin_area_2: 'Modena',
 *             admin_area_1: 'Italy'
 *         }
 *     },
 *     description: 'Acquisto XXXX prodotti store pollini.com'
 * },
 */

const CheckoutPaypal = {
    createPurchase(items, properties, countryIso, currency, address, description) {
        if(process.env.NODE_ENV === "development") {
            console.log(items, properties, countryIso, currency, address, description)
        }
        let itemList = []
        items.forEach(product => {
            itemList.push({
                name: product.attributes.name,
                unit_amount: {
                    currency_code: currency,
                    value: product.attributes.price,
                },
                tax: {
                    currency_code: currency,
                    value: "0", // TODO
                },
                quantity: product.quantity,
                sku: product.attributes.product_version_code
            })
        })

        return {
            items: itemList,
            amount: {
                currency_code: currency,
                value: properties.total,
                breakdown: {
                    item_total: {
                        currency_code: currency,
                        value: properties.subtotal,
                    },
                    shipping: {
                        currency_code: currency,
                        value: properties.shippingCost,
                    },
                    tax_total: {
                        currency_code: currency,
                        value: "0", // TODO
                    }
                }
            },
            shipping: {
                name: {
                    full_name: address.name+' '+address.surname
                },
                type: 'SHIPPING',
                address: {
                    address_line_1: address.address,
                    country_code: address.country.iso_code,
                    postal_code: address.zip_code,
                    admin_area_2: address.city,
                    admin_area_1: address.country.general_name
                }
            },
            payer: {
                email_address: 'paypalec-buyer@pollini.com',
                name: {
                    given_name: address.name,
                    surname: address.surname,
                },
                phone: {
                    phone_number: address.telephone ?? ''
                },
                address: {
                    address_line_1: address.address,
                    country_code: address.country.iso_code,
                    postal_code: address.zip_code,
                    admin_area_2: address.city,
                    admin_area_1: address.country.general_name
                }
            },
            description: description
        }
    }
}

export default CheckoutPaypal
